import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StoreService } from 'core/index';
import { KeplerGroupRankingListService } from './kepler-group-ranking.service';
import { KeplerMatch } from '../../../models/KeplerMatch';
@Component({
  selector: 'lms-kepler-group-ranking-list',
  templateUrl: './kepler-group-ranking.component.html',
  styleUrls: ['./kepler-group-ranking.component.scss'],
  providers: [KeplerGroupRankingListService]
})
export class KeplerGroupRankingListComponent implements OnChanges, OnDestroy {
  @Input() options: any;
  @Input() filters: any;
  @Input() match: KeplerMatch;

  public keplerRankingGroupListId = 'KEPLER_RANKING_GROUP_LIST';
  public items: any[];
  public dataSource: any;

  constructor(
    public translate: TranslateService,
    public keplerRankingGroupTableListService: KeplerGroupRankingListService
  ) {}

  async ngOnChanges() {
    this.dataSource = await this.keplerRankingGroupTableListService.getDatasource(
      this.keplerRankingGroupListId,
      this.options,
      this.match
    );
  }

  ngOnDestroy() {
    StoreService.remove(this.keplerRankingGroupListId);
  }

  onDatasourceUpdate() {
    StoreService.update(this.keplerRankingGroupListId, this.dataSource);
  }

  onFilterUpdate() {
    this.dataSource.refreshData({ filters: this.filters, page: 1 });
    StoreService.update(this.keplerRankingGroupListId, this.dataSource);
  }

  setCollection(collection) {
    this.items = collection;
  }
}
